/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const editPageLogic = createLogic({
	type: ActionTypes.EDIT_PAGE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());
		const { id, page, expId } = action;

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/pages/${id}`, page)
					.then(() => {
						dispatch(PagesActions.editPageSuccess(expId));
						dispatch(ControlPanelActions.hideLoading());
						done();
					})
					.catch(error => {
						dispatch(PagesActions.editPageFailure(error));
						dispatch(ControlPanelActions.hideLoading());
						done();
					});
			});
	},
});

export default [editPageLogic];
